module.exports = __webpack_public_path__ + "img/module_image.687d8279.png";